import * as constants from '../constants/actions';

const initialState = {
  userMessages: null,
  newDropdownOpen: false,
  unreadCount: 0,
  directory: null,
  confirmAlertOpen: false,
  confirmAlertText: null,
  selectedRecipient: null,
  diamonds: null,
  sentMessages: null,
  deletedMessages: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.MESSAGES_CLOSE_NEW:
      return closeNewDropdown(state, action);
    case constants.MESSAGES_OPEN_NEW:
      return openNewDropdown(state, action);
    case constants.MESSAGES_SAVE:
      return saveMessages(state, action);
    case constants.MESSAGES_SAVE_SENT:
      return saveSentMessages(state, action);
    case constants.MESSAGES_SAVE_DIRECTORY:
      return saveDirectory(state, action);
    case constants.MESSAGES_SHOW_CONFIRMATION:
      return openConfirmAlert(state, action);
    case constants.MESSAGES_HIDE_CONFIRMATION:
      return closeConfirmAlert(state, action);
    case constants.MESSAGES_OPEN_NEW_DIAMOND:
      return openNewDiamondDropdown(state, action);
    case constants.MESSAGES_DELETED_SAVE:
      return saveDeletedMessages(state, action);
	  default:
	    return state;
  }
}



function closeNewDropdown(state, action) {
  return Object.assign({}, state, {
  	newDropdownOpen: false,
    selectedRecipient: null,
    diamonds: null,
  });
}

function openNewDropdown(state, action) {
  return Object.assign({}, state, {
  	newDropdownOpen: true,
    selectedRecipient: action.recipient,
    diamonds: null,
  });
}

function openNewDiamondDropdown(state, action) {
  return Object.assign({}, state, {
    newDropdownOpen: true,
    diamonds: action.diamonds,
  });
}

function saveSentMessages(state, action) {
  return Object.assign({}, state, {
    sentMessages: action.messages,
  });
}

function saveDeletedMessages(state, action) {
  return Object.assign({}, state, {
    deletedMessages: action.messages,
  });
}

function saveMessages(state, action) {

  let messageUnread = 0;
  for(let i = 0; i < action.messages.length; i++) {
    if(action.messages[i].unread) {
      messageUnread++;
    }
  }

  return Object.assign({}, state, {
    userMessages: action.messages,
    unreadCount: messageUnread,
  });
}

function saveDirectory(state, action) {
  return Object.assign({}, state, {
    directory: action.users,
  });
}

function openConfirmAlert(state, action) {
  return Object.assign({}, state, {
    confirmAlertOpen: true,
    confirmAlertText: action.messageText,
  });
}

function closeConfirmAlert(state, action) {
  return Object.assign({}, state, {
    confirmAlertOpen: false,
    confirmAlertText: null,
  });
}